import { FormEventHandler, useContext, useEffect, useState } from 'react'
import { Button, Form, FormGroup, Row } from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import Select, { SingleValue } from 'react-select'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { v4 } from 'uuid'
import { get_Tables } from '../../../../services/campos'
import { tipos } from '../../../../services/tipos'
import { transformDependentType } from '../../../../shared/functions'
import { Field, FieldDocument } from '../Sheet'
import { SheetEditContext } from '../SheetContexts'
import { DraggableTags } from './DraggableTags'
import { useUnidades } from '../../../../shared/hooks/useUnidades'
import { useAuth2 } from '../../../authv2/Auth2Provider'
import { getAllFindTabla } from '../../../../services/tablas'
import { getSendDocumentFilexIdproceso } from '../../../../services/files'
import { getAllTipoDocumentsPag } from '../../../../services/tipodocument'

type OptionType = {
  label: string;
  value: string;
};

const DocumentEditModalForm = () => {
  const {
    closeDocumentModal,
    sheetData,
    setData,
    fieldData,
    fieldDocumentData,
    setFieldData,
    sectionData,
    setSectionData,
    tables,
    setTables,
    types,
    formDataFirmas
  } = useContext(SheetEditContext)
  const [formData, setFormData] = useState<FieldDocument>({
    id: '',
    tipo: '',
    titulo: '',
    obligatorio: false
  })

  // const [types, setTypes] = useState<Type[]>([])
  // const [tables, setTables] = useState<Table_Item[]>([])
  const [validated, setValidated] = useState(false)
  // const [selectedLabels, setSelectedLabels] = useState<string[]>([]);
  const [groupedOptions, setGroupedOptions] = useState<any>([])
  const [dataTabla, setDataTabla] = useState<any>([])
  const [dependentFieldResponses, setDependentFieldResponses] = useState<any>([])
  const [dependentFieldAux, setDependentFieldAux] = useState<Field>()
  const [documentGeneral, setDocumentGeneral] = useState<any>([])
  const [sameNameError, setSameNameError] = useState<string | null>(null)
  const {misUnidades} = useUnidades()
  const {selectedRole, idEmpresaInterna} = useAuth2()

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter' && event.target.value) {
      event.preventDefault() // Prevent the default Enter key behavior (e.g., form submission)
      event.stopPropagation() // Stop the event propagation to prevent the modal from closing
    }
  }  

  useEffect(() => {
    getDocumentProcess()
    if (fieldDocumentData.id.length > 0) {
      setFormData(fieldDocumentData)
    } else {
      setFormData({
        id: v4(),
        tipo: '',
        titulo: '',
        obligatorio: false
      })
    }
  }, [])

  const getDocumentProcess = () => {
    const option = {
        searchQuery: '',
      }
    getAllTipoDocumentsPag(1,9999,option)
    .then((response) => {      
        if (response.success) {
          setDocumentGeneral(response.data?.map((x: any) => ({
                    label: x.nombre,
                    value: x._id,
                  })))
        } else {
          console.error('Error fetching documents:', response.message)
        }
      })
      .catch((error) => {
        console.error('Error fetching documents:', error)
      })

    /* getSendDocumentFilexIdproceso(formDataFirmas.idproceso , true, formDataFirmas.unidad)
      .then((response) => {
        if (response.success) {
          setDocumentGeneral(response.data['DOCUMENTOS GENERALES']?.map((x: any) => ({
                    label: x.name,
                    value: x._id,
                  })))
        } else {
          console.error('Error fetching documents:', response.message)
        }
      })
      .catch((error) => {
        console.error('Error fetching documents:', error)
      }) */
  }  

  const handleChange = (e: any) => {
    if (e.target.name === 'name') {
      setSameNameError(null)
    }    

    setFormData({ ...formData, [e.target.name]: e.target.value })
  }


  const validateForm: FormEventHandler<HTMLFormElement> = (e) => {
    const form = e.currentTarget

    const sectionFields = sectionData.fields
    const hasSameName = sectionFields?.some(
      (x) => x.name?.toLowerCase() === formData.titulo?.toLowerCase() && formData.id !== x.id
    )

    if (!form.checkValidity()) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (hasSameName) {
      setSameNameError('El nombre se esta repitiendo en esta sección')
      e.preventDefault()
      e.stopPropagation()
      setValidated(false)
      return
    }

    if (form.checkValidity() && !hasSameName) {
      setSameNameError(null)
      handleSubmit(e)
    }

    setValidated(true)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (fieldDocumentData.id.length > 0) {
      setData({
        ...sheetData,
        sections: (sheetData.sections || []).map((x) =>
          x.id === sectionData.id
            ? {
              ...sectionData,
              fieldsDocument: (sectionData.fieldsDocument || []).map((y) => {
                if (y.id === fieldDocumentData.id) {
                  console.log(formData)
                }
                return y.id === fieldDocumentData.id ? formData : y
              }),
            }
            : x
        ),
      })
    } else {
      setData({
        ...sheetData,
        sections: (sheetData.sections || []).map((x) =>
          x.id === sectionData.id
            ? { ...sectionData, fieldsDocument: [...(sectionData.fieldsDocument || []), formData] }
            : x
        ),
      })
    }

    closeDocumentModal()
  }

  const handleRequiredCheckboxChange = (e: any) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        obligatorio: e.target.checked
      })
    } else {
      setFormData({ ...formData, obligatorio: e.target.checked })
    }
  }

  const handleInputChangeSelect = (selectOpion: any) => {
    let field = selectOpion
    setFormData((prevFormData) => {
      return { ...prevFormData, tipo: field }
    })
  }

  return (
    <>
      <Form validated={validated} onSubmit={validateForm} noValidate>
        <Form.Group className='mb-3' controlId='formComentario'>
          <Form.Label>
            Nombre
          </Form.Label>
          <Form.Control
            type='text'
            placeholder='Ingrese Nombre'
            name='titulo'
            value={formData.titulo}
            onChange={handleChange}
            className='same-height'
          />
        </Form.Group>
        <Form.Group className='mb-3' controlId='formNombre'>
          <Form.Label>Seleccione el Tipo de Documento</Form.Label>
          <Select
          name={formData.id}
          placeholder='Seleccione un campo'
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '34px',
              height: '34px',
              fontFamily: 'inherit',
              fontSize: '0.95rem',
              color: '#5e6278',
            }),
          }}
          options={documentGeneral && documentGeneral.length > 0
              ? documentGeneral.map((t:any) => ({label: t.label, value: t.value})) : [] }
          value={
            formData.tipo
              ? formData.tipo
              : null
          }
          onChange={(selectedOption) => {
            handleInputChangeSelect(selectedOption)
          }}
        />

          {/* <Form.Control
            as='select'
            name='dependentFieldResponse'
            value={formData.tipo}
            onChange={handleChange}
          >
            <option value=''>Seleccione un campo</option>
            {documentGeneral
              ? documentGeneral?.map((response: any) => (
                <option key={response.value} value={response.label}>
                  {response.label}
                </option>
              ))
              : null}
          </Form.Control> */}

          {/* <Select<OptionType>
          name="tipo"
          placeholder="Seleccione un campo"
          defaultValue={
                    formData.tipo
                      ? formData.tipo
                      : null
                  }
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '34px',
              height: '34px',
              fontFamily: 'inherit',
              fontSize: '0.95rem',
              color: '#5e6278',
            }),
          }}
          options={documentGeneral}
          onChange={(selectedOption) => {
            handleInputChangeSelect(selectedOption)
          }}
        /> */}
        </Form.Group>

        {/* <Form.Group className='mb-3' controlId='formComentario'>
          <Form.Label>
            Limite de días
            <i
              className={'fas fa-exclamation-circle ms-2 fs-5 text-primary'}
              data-tooltip-id={'my-tooltip-1'}
            ></i>
            <ReactTooltip
              id={'my-tooltip-1'}
              place='bottom'
              variant={'info'}
              content={'Limites de dias que tiene el usuario para firmar'}
            />
          </Form.Label>
          <Form.Control
            type='number'
            placeholder='Ingrese un limite'
            name='limite'
            value={formData.limite}
            onChange={handleChange}
            className='same-height'
          />
        </Form.Group> */}

        {/* <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='visibleCheckbox'
            // label='Visible'
            className='form-check-input'
            checked={formData.visible}
            onChange={(event) => handleVisibleCheckboxChange(event)}
          />
          <label htmlFor='visibleCheckbox'>Visible</label>
        </div>

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='editableCheckbox'
            // label='Editable'
            className='form-check-input'
            checked={formData.editable}
            onChange={(event) => setFormData({ ...formData, editable: event.target.checked })}
          />
          <label htmlFor='editableCheckbox'>Editable</label>
        </div> */}

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='requiredCheckbox'
            // label='Obligatorio'
            className='form-check-input'
            checked={formData.obligatorio}
            onChange={(event) => handleRequiredCheckboxChange(event)}
          />
          <label htmlFor='requiredCheckbox'>Obligatorio</label>
        </div>

        {/* <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='variableCheckbox'
            // label='Replicable'
            className='form-check-input'
            checked={formData.variable}
            onChange={(e) => {
              setFormData({ ...formData, variable: e.target.checked })
            }}
          />
          <label htmlFor='variableCheckbox'>Replicable</label>
        </div> */}
        {/* <Form.Check
          type='checkbox'
          id='actualizableCheckbox'
          label='Actualizable'
          className='mb-3'
          checked={formData.actualizable}
          onChange={(event) => handleActualizableCheckboxChange(event)}
        /> */}

        <Row>
          <div className='d-flex justify-content-end'>
            <Button
              variant='light'
              className='mx-3'
              type='reset'
              onClick={() => {
                closeDocumentModal()
              }}
            >
              Cancelar
            </Button>
            <Button variant='primary' type='submit'>
              Guardar
            </Button>
          </div>
        </Row>
      </Form>
    </>
  )
}

export { DocumentEditModalForm }
